import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { DialogConfirm } from 'components'
import { cloneDeep } from 'lodash'
import { Alert, TextField } from '@mui/material'
import { createBackgroundCheck } from "../../../services/apiKYP"
import { cpfValid } from "../../../utils/validators"

const initialState = {
  person_cpf: '',
}

const initialErrors = {
  person_cpf: false,
}

function BackgroundCheckForm(props) {
  const { handleClose, open } = props

  const token = useSelector((state) => state.auth.access_token)

  const [formState, setFormState] = useState(initialState)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [alreadyHasBgc, setAlreadyHasBgc] = useState(false)
  const handleSubmit = () => {
    createBackgroundCheck(token, formState)
      .then((response) => {
        if (response.status === 201) {
          setAlreadyHasBgc(!response.data.was_created_new)
          if (response.data.was_created_new) {
            toast.success('Análise de background check solicitada com sucesso')
            handleClose()
          }
        }
      })
      .catch(() => {
        setAlreadyHasBgc(false)
        toast.error('Houve um erro na criação do background check')
      })
      .finally(() => {
      })
  }

  const handleFormValidation = () => {
    const errors = cloneDeep(initialErrors)

    if (!cpfValid(formState.person_cpf)) {
      errors.person_cpf = true
    }

    if (Object.keys(errors).some((key) => errors[key])) {
      setFormErrors(errors)
      toast.error('Informe um CPF válido')
    } else {
      handleSubmit()
    }
  }

  const handleFieldChange = (event) => {
    const key = event.target.id
    const newFormState = cloneDeep(formState)
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  return (
    <DialogConfirm
      open={open}
      title="Background Check"
      onConfirm={handleFormValidation}
      onCancel={handleClose}
      btnCancelText="Cancelar"
      contextText='Para realizar uma análise de background check, digite um número de CPF válido.'
      showCloseButton={true}
    >
      <React.Fragment>
        <TextField
          id="person_cpf"
          label='CPF'
          onChange={handleFieldChange}
          value={formState.person_cpf}
          error={formErrors.person_cpf}
          size="small"
          fullWidth
          margin="dense"
          autoFocus
          variant="standard"
          required
        />

        { !alreadyHasBgc && <Alert severity="info" style={{ marginTop: '8px' }}>
          Se uma análise de Background Check foi realizada há menos de <strong>30 dias</strong> para o CPF fornecido,
          ela será reutilizada e não será criada uma nova.
        </Alert> }

        { alreadyHasBgc && <Alert severity="warning" style={{ marginTop: '8px' }}>
          Já existe uma análise recente para o CPF informado. Pesquise no painel de Background Checks.
        </Alert> }
      </React.Fragment>
    </DialogConfirm>
  )
}

export default BackgroundCheckForm
